/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Summary_Bar_Rate_WpmInputs */

const en_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const fr_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const de_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const it_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const ru_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const es_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const zh_cn2_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const ja_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const hi_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

const pt_pt2_options_metrics_summary_bar_rate_wpm = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words Per Minute (WPM)`)
};

/**
* | output |
* | --- |
* | "Words Per Minute (WPM)" |
*
* @param {Options_Metrics_Summary_Bar_Rate_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_summary_bar_rate_wpm = /** @type {((inputs?: Options_Metrics_Summary_Bar_Rate_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Summary_Bar_Rate_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "de") return de_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "it") return it_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "ru") return ru_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "es") return es_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "ja") return ja_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "hi") return hi_options_metrics_summary_bar_rate_wpm(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_summary_bar_rate_wpm(inputs)
	return en_options_metrics_summary_bar_rate_wpm(inputs)
});